import React, {Component} from 'react';

import {setCookieSessionOnly} from '../../../utils/cookies';
import {removeCourseworkSession} from "../coursework/coursework-utils";

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

// import LoginFormModal from '../Login/LoginFormModal';
import LoginForm from '../Login/LoginForm';
import Main from '../../../components/Main/Main';
import SessionTimeoutModal from '../../../components/SessionTimeout/SessionTimeoutModal';
import CourseworkLoginModal from "../coursework/login/CourseworkLoginModal";

import classes from './PublicHome.module.scss';
import TestimonialCarousel from "./Testimonials/TestimonialCarousel";
// import RetinaImage from "../../../components/RetinaImage/RetinaImage";
import Expander from "../../../components/Expander/Expander";


/**
 * CHECKED-2021
 */
class PublicHome extends Component {


    state = {
        displayLogin:false,
        displayCourseworkLogin:false,
        displaySessionExpiredModal:false,
        courseworkCode:null,
    };


    componentDidMount(){

        //
        // Clear coursework session.
        //
        removeCourseworkSession();

        const urlParams = new URLSearchParams(this.props.location.search);

        // if(urlParams.get('login')==="y"){
        //     this.setState({
        //         displayLogin:true
        //     })
        // }

        const crswrk_cd = urlParams.get('crswrk_cd');
        if(crswrk_cd){
            this.setState({
                displayCourseworkLogin:true,
                courseworkCode:crswrk_cd,
            });
        }

        const target = urlParams.get('target');
        if(target && target.startsWith("/home")){
            setCookieSessionOnly("ami-target", target);
            setCookieSessionOnly("ami-target-timestamp", new Date().getTime());
        }


        if(urlParams.get('session-expired')==="y"){
            this.setState({
                displaySessionExpiredModal:true
            });

            this.props.history.replace("/")
        }
    }





    // displayLoginFormHandler = () => {
    //
    //     // DO NOT REMOVE!!!
    //     this.removeCourseworkParam();
    //
    //     this.setState({
    //         displayLogin:true
    //     });
    // };

    // closeLoginFormHandler = () => {
    //     this.setState({
    //         displayLogin:false
    //     });
    // };


    closeCourseworkLoginHandler = () => {

        // DO NOT REMOVE!!!
        this.removeCourseworkParam();

        this.setState({
            displayCourseworkLogin:false
        });
    };


    //
    // ** IMPORTANT **
    //
    // removeCourseworkParam() is required when a real user logs in.
    //
    removeCourseworkParam = () => {
        const { history, location } = this.props;
        const searchParams = new URLSearchParams(location.search);

        searchParams.delete("crswrk_cd");

        history.replace({
            pathname: location.pathname,
            search: searchParams.toString()
        });
    }

    closeSessionExpireModal = () => {
        this.setState({
            displaySessionExpiredModal:false
        });
    };



    render() {

        return (
            <Main>

                <Container>
                    <Row>
                        <Col md={6} className={classes.noRightPadding}>
                            <h2>Committed to providing meaningful education to help advance surgical techniques and optimize patient outcomes</h2>
                            <TestimonialCarousel/>
                        </Col>
                        <Col md={6}>
                            <LoginForm/>
                        </Col>
                    </Row>

                    {/*<Row className={"mt-5"}>*/}
                    {/*    <Col sm={6}>*/}
                    {/*        /!*<h2>The Allergan Medical Institute® Website is a one-stop shop for all things Medical Education</h2>*!/*/}
                    {/*        /!*<p>Attendees can view a variety of on-demand content from panel webcast presentations to surgical technique videos, submit questions, contact their sales representative, register for an in-person or virtual live program, and have all of the resources that Allergan Medical Institute® has to offer, right at their fingertips.</p>*!/*/}



                    {/*    </Col>*/}
                    {/*    <Col sm={6}>*/}
                    {/*        <div className={classes.publicHomePromoImageContainer}>*/}
                    {/*            <RetinaImage*/}
                    {/*            src={[*/}
                    {/*            require("../../../assets/images/publicHome/public-home.png").default,*/}
                    {/*            require("../../../assets/images/publicHome/public-home@2x.png").default,*/}
                    {/*            require("../../../assets/images/publicHome/public-home@3x.png").default]} />*/}
                    {/*        </div>*/}
                    {/*    </Col>*/}
                    {/*</Row>*/}

                    <section className={"py-5"}>

                        <h2>Login to discover:</h2>

                        <Container>

                        </Container>

                    </section>

                    <Row>
                        <Col className={"my-3 my-lg-0"} md={12} lg={4}>
                            <div className={classes.discoverTiles + " mx-2"}>
                                <h3>Variety of Education</h3>
                                <p>Immersive learning with on-demand content from surgical technique videos, patient marking and measurements, and best practices for patient care.</p>
                            </div>
                        </Col>
                        <Col className={"my-3 my-lg-0"} md={12} lg={4}>
                            <div className={classes.discoverTiles + " mx-2"}>
                                <h3>Expert Faculty</h3>
                                <p>AMI Surgeon Faculty deliver pearls on enhancing techniques and optimizing patient outcomes.</p>
                            </div>
                        </Col>
                        <Col className={"my-3 my-lg-0"} md={12} lg={4}>
                            <div className={classes.discoverTiles + " mx-2"}>
                                <h3>Our Products</h3>
                                <p>Allergan Aesthetics offers products developed to help you achieve your patients’ desired outcomes.</p>
                            </div>
                        </Col>
                    </Row>

                    <section className={"py-5 " + classes.faq}>

                        <h2>Frequently Asked Questions</h2>

                        <Expander title={"What is AllerganSurgicalEducation.com?"}>
                            <p>AllerganSurgicalEducation.com is a comprehensive learning platform featuring in-depth surgical on-demand education and training. It is designed to provide a learning experience that helps surgeons of all levels further their knowledge, refine their skills, and advance their surgical expertise in aesthetic breast surgery, breast reconstruction, fat grafting, and abdominal wall reconstruction.</p>
                        </Expander>

                        <Expander title={"Do I need to register to have access to AllerganSurgicalEducation.com?"}>
                            <p>Yes, registration is required to view educational content, live programming, and request a program. You will need your NPI and Medical License number to have continued access.
                            </p>
                        </Expander>

                        <Expander title={"How do I obtain training on facial aesthetics, skincare,  body contouring, and business education?"}>
                            <p>Education on facial aesthetics, skincare, and body contouring is on AMI’s aesthetic website, <a className={"underline"} href={"http://www.amionline.com/"} target="_blank" rel="noreferrer">AMIOnline.com</a>. You will need a valid Allergan Aesthetics ship-to number to gain full access to the site.
                            </p>
                        </Expander>

                        <Expander title={"How can I get certifications and complete attestations required for the purchase of Allergan Aesthetics products?"}>
                            <p>Log on to <a className={"underline"} href={"http://www.amionline.com/"} target="_blank" rel="noreferrer">AMIOnline.com</a>. For product purchasing, a valid NPI is also required for prescribers. The NPI must be entered into the AMI Online portal to unlock your account’s product purchasing access.
                            </p>
                        </Expander>
                    </section>

                </Container>

                {/*<PromotionCarousel/>*/}



                {/*<Testimonials className={"mt-5"}/>*/}

                <SessionTimeoutModal show={this.state.displaySessionExpiredModal} hide={this.closeSessionExpireModal}/>


                {this.state.displayCourseworkLogin? (
                    <CourseworkLoginModal
                        courseworkCode={this.state.courseworkCode}
                        show={this.state.displayCourseworkLogin}
                        hide={this.closeCourseworkLoginHandler}/>
                ) :null
                }
            </Main>
        );
    }
}


export default PublicHome;
